// extracted by mini-css-extract-plugin
export var container = "_19-0";
export var icon = "_19-1";